
import { useCheckData } from "../../../hooks";
import { useMisItemsTrabajo } from "../../../hooks/cache";
import { useModalStore } from "../../../stores";
import { CargandoMedio, ModalFormulario } from "../../components";
import { BotonesGroup } from "../../components/botones";
import { BuscadorXTermino } from "../../components/buscadores";
import { LayoutCrearDoc } from "../../layouts";
import { FormularioAsignarColaborador, TablaItemsPorTrabajar } from "../components";



export const MisItemsDeTrabajo = () => {


    const { data, isLoading, chagePage, page, termino, chageTermino } = useMisItemsTrabajo();
    const { selected, handleSelectAllClickUser, handleClick, isSelected, setSelected } = useCheckData(data || []);
    const { modalFormToggle, tipo } = useModalStore();


    const options = [
        { label:'Asignar Items', onClick:() => modalFormToggle(true, 'asignarcolaborador'), icono:'asignar', disabled:(selected?.length < 1) },
    ];



    return (
        <LayoutCrearDoc titulo='Trabajos Asignables' add={false}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de mis items de producción..." />
            :   <>
                <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="item" playhol="op o producto" />
                {/* <TablaItemsProduccion data={data || []} chagePage={chagePage} page={page} entregar /> */}
                <BotonesGroup botonesOpciones={options} />
                <TablaItemsPorTrabajar 
                    data={data || []} 
                    chagePage={chagePage} page={page} 
                    selected={selected} 
                    handleSelectAllClickUser={handleSelectAllClickUser} 
                    handleClick={handleClick} 
                    isSelected={isSelected}
                />
                </>
            }

            {(tipo === 'asignarcolaborador') &&
            <ModalFormulario titulo="Asignar Colaborador" valor={{}} onClose={() => modalFormToggle(false)}>
                <FormularioAsignarColaborador selected={selected} setSelected={setSelected} />
            </ModalFormulario>
            }
        </LayoutCrearDoc>
    )
}
